<div class="row match-height justify-content-center">
    <div class="col-md-12">
        <div class="content-wrapper container-xxl p-0">
            <div class="content-body">
                <!-- Add your content header component here if needed -->
                <app-content-header [contentHeader]="contentHeader"></app-content-header>
  
                <div class="row match-height">
                    <div class="col-md-4">
                        <div *ngIf="pages.length > 0">
                            <ul class="list-unstyled">
                              <li *ngFor="let item of pages">
                                <a href="javascript:void" (click)="pageDetails(item)" class="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">
                                  {{ toTitleCase(item.page_title) }}
                                </a>
                              </li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-md-8" *ngIf="page_details">
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title">{{ toTitleCase(page_details.page_title) }}</h4>
                                <p [innerHTML]="page_details.page_desc"></p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  </div>